import * as yup from 'yup';

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;
export const PASSWORD_COMPLEXITY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
export const PASSWORD_COMPLEXITY_MESSAGE =
  'Пароль должен содержать хотя бы одну заглавную букву, одну строчную букву и одну цифру';

export const newPasswordFieldSchema = (options?: { requiredMessage?: string }) =>
  yup
    .string()
    .required(options?.requiredMessage ?? 'Введите пароль')
    .min(
      PASSWORD_MIN_LENGTH,
      `Пароль должен содержать минимум ${PASSWORD_MIN_LENGTH} символов`,
    )
    .max(
      PASSWORD_MAX_LENGTH,
      `Пароль не должен превышать ${PASSWORD_MAX_LENGTH} символов`,
    )
    .matches(PASSWORD_COMPLEXITY_REGEX, PASSWORD_COMPLEXITY_MESSAGE);

export const confirmPasswordFieldSchema = (passwordRef = 'password') =>
  yup
    .string()
    .required('Повторите пароль')
    .oneOf([yup.ref(passwordRef)], 'Пароли не совпадают');
